"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Task = void 0;
const React = __importStar(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const Button_1 = require("../button/Button");
const IconTextSpan_1 = require("../icon-text-span/IconTextSpan");
const theme_1 = __importDefault(require("../styles/theme"));
const types_1 = require("../../../entities/fact/types");
const button = (text, onClick, link, disabled = false) => {
    if (!text)
        return null;
    const props = {
        bgColor: theme_1.default.colours.neutral.white,
        activeColor: theme_1.default.colours.neutral.lightest,
        hoverColor: theme_1.default.colours.neutral.lightest,
        color: theme_1.default.colours.text.darkest,
    };
    if (disabled) {
        return React.createElement(React.Fragment, null);
    }
    if (onClick) {
        return (React.createElement(Button_1.Button, Object.assign({}, props, { "data-testid": "testing-task-button", onClick: onClick }), text));
    }
    else {
        return (React.createElement(Button_1.LinkButton, Object.assign({}, props, { to: link || '', "data-testid": "testing-task-anchor" }), text));
    }
};
const Wrapper = styled_1.default.div `
	min-width: 300px;
	max-width: 100%;
	border: 1px solid ${theme_1.default.colours.neutral.light};
	border-radius: ${theme_1.default.layout.radius.squared};
	margin-bottom: ${theme_1.default.layout.spacing.standard};
	&:last-child {
		margin-bottom: ${theme_1.default.layout.spacing.large};
	}
	> * {
		box-sizing: border-box;
	}
`;
const completionColour = (completion) => {
    switch (completion) {
        case types_1.TaskCompletionState.INPUT_REQUIRED:
            return theme_1.default.palette.red.tint;
        case types_1.TaskCompletionState.REVIEW_REQUIRED:
            return theme_1.default.palette.blue.tint;
        case types_1.TaskCompletionState.DISABLED:
            return theme_1.default.palette.greyscale.lighter;
        default:
        case types_1.TaskCompletionState.COMPLETE:
            return theme_1.default.palette.green.tint;
    }
};
const Header = styled_1.default.div `
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 15px ${theme_1.default.layout.spacing.standard};
	background-color: ${({ completion }) => completionColour(completion)};
	min-height: 70px;
`;
const TextWrapper = styled_1.default.div `
	padding: ${theme_1.default.layout.spacing.smaller} ${theme_1.default.layout.spacing.standard};
	word-break: break-word;
`;
const Task = (props) => {
    const { completion, title, link, buttonText, onClick, children } = props;
    const disabled = completion === types_1.TaskCompletionState.DISABLED;
    return (React.createElement(Wrapper, { "data-testid": "testing-task" },
        React.createElement(Header, { "data-testid": "testing-task-header", completion: completion },
            React.createElement(IconTextSpan_1.IconTextSpan, Object.assign({}, IconTextSpan_1.IconCompletionStyles[completion], { iconSize: "large", text: title })),
            button(buttonText, onClick, link, disabled)),
        children && React.createElement(TextWrapper, null, children)));
};
exports.Task = Task;
//# sourceMappingURL=Task.js.map